import { Platform, } from '@lucidlink/dto/validation';
import { getClientData, ParserOSNames, } from '@lucidlink/uicore/services/getClientData';
function parserUAPlatformToPlatform(uaPlatform) {
    switch (uaPlatform) {
        case ParserOSNames.Android:
            return Platform.ANDROID;
        case ParserOSNames.IOS:
            return Platform.IOS;
        case ParserOSNames.Windows:
            return Platform.WINDOWS;
        case ParserOSNames.MacOS:
            return Platform.OSX;
        case ParserOSNames.Linux:
            return Platform.LINUX;
        default:
            return 'Other';
    }
}
export function getAdditionalInfo() {
    const clientData = getClientData();
    const result = {
        application: process.env.SDK_APPLICATION_NAME,
        componentVersion: 'unknown',
        platform: parserUAPlatformToPlatform(clientData.osName ?? 'unknown'),
        platformVersion: clientData.platformVersion ?? 'unknown',
        webBrowser: clientData.browserName ?? 'unknown',
    };
    return result;
}
